import React from 'react';
import './Ye1.css';
import Footer from '../Footer/Footer';

function Ye1() {
  return (
    <div className='day1'>
      <div className='prog_header'>
        <h1 className='prog_header_kippra'>6TH KIPPRA ANNUAL REGIONAL CONFERENCE  </h1>
        <h1 className='prog_header_theme'>THEME: ACCELERATING ECONOMIC GROWTH AND DEVELOPMENT FOR ASALS IN </h1>
        <h1 className='prog_header_theme'>KENYA</h1>
        <h1 className='prog_header_kippra'> YOUTH SIDE EVENT PROGRAMME  </h1>
      </div>
      <div>
      
        <table>
        <p style={{fontWeight: "bold"}}>Day 1</p>
          <thead>
            <tr>
              <th style={{ fontWeight: '600', textDecoration: 'none' }} colSpan="3">Wednesday: 21ST JUNE 2023</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ fontWeight: "bold" }}>8.30 - 9.00</td>
             <td></td>
              <td>Arrival and Registration  <br /> <br />
              Entertainment <br />
                </td>
            </tr>
            <tr>
              <td >9.00 - 10.00</td>
              <td > </td>
              <td >Prayer and National Anthems <br />
                    Conference Objectives <br />
                    Welcoming Remarks  <br />
                    Documentary and Presentation <br />  </td> {/* New empty column */}
            </tr>
            <tr>
              <td  >10.30 - 11.00</td>
              <td >  </td>
              <td style={{ fontWeight: "bold" }}>TEA BREAK<br /> </td> {/* New empty column */}
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style={{ fontWeight: 'bold', textDecoration: 'none', backgroundColor: "white", color: "black" }} colSpan="3">THEME 1: YOUTH AND GOVERNMENT</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ fontWeight: "normal" }}>11.00 - 12.00</td>
             <td></td>
              <td style={{fontWeight:"bold"}}>Keynote Address on Youth Empowerment  <br /> <br />
              <span style={{fontWeight: "normal"}}>Plenary – Youth Expectations and Experiences</span>
                </td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style={{ fontWeight: 'bold', textDecoration: 'none', backgroundColor: "white", color: "black" }} colSpan="3">THEME 2: NAVIGATING CAREER</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ fontWeight: "normal" }}>12.00 - 13.00</td>
             <td></td>
              <td style={{fontWeight:"bold"}}>Motivation Session for Youth  <br />
              <span style={{fontWeight: "normal"}}>Discovering youth potential and associated roles in the community <br /> <br />
                                                    Plenary – What it takes</span>
                </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "normal" }}>13.00 - 14.00</td>
             <td></td>
              <td style={{fontWeight:"bold"}}>LUNCH BREAK   <br />
                </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "normal" }}>14.00 - 15.30</td>
             <td></td>
              <td style={{fontWeight:"bold"}}>Transitioning to the world of work  <br /> <br />
              <span style={{fontWeight: "normal"}}>Plenary – Preparing to take off and participate <br /> 
                                                    </span>
                </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "normal" }}>15.30 - 17.00</td>
             <td></td>
              <td style={{fontWeight:"bold"}}>Role of physical and mental health in career development  <br /> <br />
              <span style={{fontWeight: "normal"}}>Plenary – Q&A <br /> 
                                                    </span>
                </td>
            </tr>
            <tr>
              <td >17:00 - 17.30</td>
              <td ></td>
              <td style={{ fontWeight: "normal" }}> Refreshment and Departure (End of Day 1)</td> {/* New empty column */}
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Footer />
      </div>
    </div>
  )
}

export default Ye1;
